export const PRODUCT_LOADING='PRODUCT_LOADING'
export const PRODUCT_DATA='PRODUCT_DATA';
export const PRODUCT_ERROR='PRODUCT_ERROR'

export const RIGHT_APPROVED='RIGHT_APPROVED'

export const CROSS_MISSING='CROSS_MISSING';
export const CROSS_MISSING_URGENT='CROSS_MISSING_URGENT'


export const ADD_PRODUCT='ADD_PRODUCT';
